/* eslint-disable import/prefer-default-export */

import { getSign } from '@/api/card';
import { env } from '@hb/NBridge/lib/h5';
import { getWechatUserInfo } from '../api/wechat';
import { loadScript } from './loadScript';
import { ParamsUtil } from './params';
import { Storage } from './storage';

let $$wechatConfigResult = null;
let work = Promise.resolve([]);

export function configWechatSDK() {
  if (!env.isWechatMini && !env.isWeixin) {
    return Promise.reject(new Error('不是微信环境'));
  }
  if ($$wechatConfigResult === 1) {
    return Promise.resolve();
  }
  if ($$wechatConfigResult === 0) {
    return Promise.reject();
  }
  work = Promise.all([
    getSign({
      bizCode: 'SA-HELLO',
      url: window.location.href.split('#')[0],
    })
      .then((v) => v.data)
      .catch(() => null),
    loadScript(
      'https://m.hellobike.com/resource/common/thrid-party-scripts/2l8swgipf65cjeol9-7JC.js',
    ),
  ]).then(([data]) => {
    if (window.wx && data) {
      window.wx.config({
        debug: false,
        appId: 'wxb2315cf308c9a24d',
        timestamp: data.timestamp,
        nonceStr: data.nonceStr,
        signature: data.signature,
        openTagList: ['wx-open-launch-app', 'wx-open-launch-weapp'],
        jsApiList: [
          'onMenuShareTimeline',
          'onMenuShareAppMessage',
          'onMenuShareQQ',
          'onMenuShareWeibo',
          'onMenuShareQZone',
          'hideMenuItems',
          'showMenuItems',
          'hideAllNonBaseMenuItem',
          'showAllNonBaseMenuItem',
          'getLocation',
          'closeWindow',
          'scanQRCode',
          'chooseImage',
          'chooseWXPay',
          'invokeMiniProgramAPI',
          'requestPayment',
        ],
      });
      return new Promise((resolve, reject) => {
        window.wx.ready(() => {
          $$wechatConfigResult = 1;
          resolve();
        });
        window.wx.error(() => {
          $$wechatConfigResult = 0;
          reject();
        });
      });
    }
    return Promise.reject(new Error('wechat sdk 初始化失败'));
  });
  return work;
}

export const WechatUtil = new (class {
  businessType = 0

  APP_ID = 'wxb2315cf308c9a24d'

  configWechatSDK = configWechatSDK

  redirectToGetCode(backUrl, scope) {
    const url = `https://m.hellobike.com/weiAuthrize/index-v2.html?a=${Math.random()}`;
    const encodedBackUrl = encodeURIComponent(backUrl);
    const redirectUri = `${url}&appid=${this.APP_ID}&redirect_uri=${encodedBackUrl}&response_type=code&scope=${scope}&state=STATE`;
    window.location.replace(redirectUri);
  }

  /** 链接上没取到会自动跳去授权页 默认缓存7*24小时 */
  // eslint-disable-next-line no-unused-vars
  getCode(scope = 'snsapi_base', forceRefresh = false, hour = 168, redirectUrl = window.location.href) {
    if (window.h5_market_is_getting_code) {
      return Promise.resolve(null);
    }

    window.h5_market_is_getting_code = true;

    return new Promise((resolve, reject) => {
      const code = ParamsUtil.getParam('code');
      if ((!code || forceRefresh)) {
        let chances = Number(Storage.getItem('getcode_chances') || 1);
        chances += 1;
        if (chances >= 3) {
          Storage.removeItem('getcode_chances');
          window.h5_market_is_getting_code = false;
          // throw new Error(`连续获取code${chances - 1}次失败, 请关闭页面重试`);
          reject(new Error(`连续获取code${chances - 1}次失败, 请关闭页面重试`));
        }
        Storage.setItem('getcode_chances', chances);
        this.redirectToGetCode(redirectUrl, scope);
      } else {
        window.h5_market_is_getting_code = false;
        Storage.removeItem('getcode_chances');
        resolve(code);
      }
    });
  }

  /**
   * return: {unionid,openid,nickname,headimgurl,sex}
   * 拿用户信息scope必须是snsapi_userinfo
   * @see https://yapi.hellobike.cn/project/39/interface/api/53479
   */
  async getWechatUserInfo() {
    const { businessType } = this;
    const scope = 'snsapi_userinfo';
    let chances = Number(Storage.getItem('chances') || 1);
    chances += 1;
    if (chances >= 4) {
      Storage.removeItem('chances');
      return null;
    }
    Storage.setItem('chances', chances);
    try {
      const openId = Storage.getItem(`${scope}wx_open_id_`);
      let code;
      if (!openId) {
        code = await this.getCode(scope);
      }
      const data = await getWechatUserInfo({
        code,
        openId,
        businessType,
        scope,
      });
      Storage.removeItem('chances');
      return data;
    } catch (e) {
      // 缓存的openId过期了
      if (e.response && e.response.data && e.response.data.code === 146) {
        Storage.removeItem(`${scope}wx_open_id_`);
        this.getWechatUserInfo();
      }
      return null;
    }
  }
})();
